import {ProgramNavigationItem} from 'models/program/ProgramModel'
import {SpeakerModel} from 'models/program/SpeakerModel'
import qs from 'query-string'
import React from 'react'
import {AnchorAttrs} from 'types'
import useRouter from 'use-react-router'
import {getSearchParamsFromRouter, routeToParams} from 'util/hooks'

export type ProgramParams = {
	event?: string
	popup?: string
} & Record<string, string>

export const closeProgramItemPopup = (router, item: ProgramNavigationItem) => {
	const params = getSearchParamsFromRouter(router)
	routeToParams(router, {...params, popup: undefined})

	if (!params.popup) {
		if (item instanceof SpeakerModel) {
			const speakersUrl = item.url
				.split('/')
				.slice(0, -1)
				.join('/')
			router.history.push(speakersUrl)
		} else {
			const paramsString = qs.stringify({event: item.day?.path})
			const url = item.program.url + (paramsString ? '?' + paramsString : '')
			router.history.push(url)
		}
	}
}

export const openProgramItemPopup = (
	router,
	item: ProgramNavigationItem,
	extra = {}
) => {
	const params = getSearchParamsFromRouter(router)
	routeToParams(router, {...params, popup: item.path, ...extra})
}

export const ProgramLink: React.FC<{
	item: ProgramNavigationItem
} & AnchorAttrs> = ({item, children, ...rest}) => {
	const router = useRouter()
	if (!item) return <>{children}</>

	return (
		<a
			{...rest}
			href={item.url}
			onClick={e => {
				e.preventDefault()
				if (item instanceof SpeakerModel && item.sessions.length === 1) {
					openProgramItemPopup(router, item.sessions[0], {speaker: item.path})
				} else {
					openProgramItemPopup(router, item)
				}
				return true
			}}
		>
			{children}
		</a>
	)
}
